import React, { useEffect, useRef, useState } from 'react'
import * as gtUtil from "../../../core/utility";
import InstagramIcon from "../../../components/icons/instagram-icon";
import { BrandDataService } from "../../../core/services/brand-data.service";
import { Launch, Search } from "@mui/icons-material";
import InstagramIcon1 from '../../../components/icons/instagram-icon1';
import YouTube from '@mui/icons-material/YouTube';
import { DetailedInfluencerAnalyticsBrandOrganic } from './detailed-influencer-analytics';
import { connect } from "react-redux";
import { Loading } from "../../../redux/action";
import { BrandPulseProfileCard } from './brand-pulse-profile-card';
import "./brand-data.scss";
import { MetricsCard } from './metrics-card';
import { FollowersGrowthChart } from './followers-growth-chart';
import { ContentTypeChart } from './content-type-chart';
import { InfluencerGrid } from './influencer-grid';
import { PostErChart } from './post-er-chart';
import { TopInfluencer } from './topInfluencer';
import { ComparisionTable } from './comparsion-table';
import { EngagedInfluencers } from './engaged-influencers';
import { RolesService } from '../../../core/services/roles.service';
import { LocalService } from '../../../core/services/local.service';
import { useNavigate } from 'react-router-dom';
import { EngagedInfluencerTable } from './engaged-influencer-table';
import { FormControl, Grid, InputLabel, MenuItem, Select, Skeleton, Tabs } from '@mui/material';
import { ColumnChart, PieChart } from '../../../components/charts';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3d from 'highcharts/highcharts-3d'
import WordCloudComponent from './brandPulseWordCloud';
import { CommentsTab } from './comments-tab';
import { EmvChart } from './emv-chart';
import { EmvROI } from './emv_roi_chart';
import { BrandErVerticalChart } from './brand-er-vertical-chart';
import { DetailedInfluencerAnalyticsPaid } from './detailed-influencer-analytics-paid';
import { DetailedInfluencerAnalyticsBrand } from './detailed-influencer-analytics-brand';
import { Nav, Tab } from 'react-bootstrap';
import { EngagedInfluencersAmount } from './engaged-influencer-amount';
import MaterialSymbol from '../../../components/icons/material-symbol';

const methods = new gtUtil.Methods()
const rolesService = new RolesService();
const localService: LocalService = new LocalService();
const brandDataService: BrandDataService = new BrandDataService();
Highcharts3d(Highcharts);

interface Props {
  UserReducer: any;
  loading: (data: boolean) => void;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface InfluencerTableData {
  paid: any[];
  paid_videos: any[];
  paid_images: any[];
  brand_organic: any[];
  brand_organic_videos: any[];
  brand_organic_images: any[];
  brand: any[];
  brand_videos: any[];
  brand_images: any[];
  total: string;
  total_pages: string;
  [key: string]: any;
}

type AccordionType = "paid" | "brand_organic" | "brand" | undefined;

const influencerTypeRange:any = {
  Nano: "1K - 10K",
  Micro: "10K - 50K",
  "Micro Plus": "50K - 100K",
  Macro: "100K - 500K",
  "Macro Plus": "500K - 1M",
  Mega: "1M - 5M",
  "Mega Plus": "5M+",
}
const BrandPulse: React.FC<Props> = ({ loading, ...props }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataApi1, setDataApi1] = useState<any>([]);
  const [dataApi2, setDataApi2] = useState<any>([]);
  const [dataApi3, setDataApi3] = useState<any>([]);
  const [dataApi4, setDataApi4] = useState<any>([]);
  const [dataApi5, setDataApi5] = useState<any>([]);


  const [searchValue, setSearchValue] = useState("")
  const [searchList, setSearchList] = useState<any>([]);
  const [brandImage, setBrandImage] = useState("")
  const [brandRefId, setBrandRefId] = useState(0);
  const [detailedInfluencer, setDetailedInfluencer] = useState("")
  const [profileData, setProfileData] = useState("");
  const [isSelected, setIsSelected] = useState(false)
  const [userStatus, setUserStatus] = useState(false)
  const [postFrequency, setPostFrequency] = useState("")
  const [profileEr, setProfileEr] = useState<any>([]);
  const [paidFrequency, setPaidFrequency] = useState<any>([]);
  const [organicFrequency, setOrganicFrequency] = useState<any>([]);
  const [subsGrowthStockChartData, setSubsGrowthStockChartData] = useState<any[]>([]);
  const [contentTypeChart, setContentTypeChart] = useState("")
  const [influencerData, setinfluencerData] = useState<any[]>([]);
  const [postErChart, setPostErChart] = useState<any[]>([]);
  const [topPaidInfluencer, setTopPaidInfluencer] = useState<any[]>([]);
  const [topOrganicInfluencer, setTopOrganicInfluencer] = useState<any[]>([]);
  const [topCompetitors, setTopCompetitors] = useState<any[]>([]);
  const [comparisionData, setComparisionData] = useState<any[]>([]);
  const [influencerDetails, setInfluencerDetails] = useState<any[]>([]);
  const [paidOrganicER, setPaidOrganicER] = useState<any[]>([]);
  const [worldCloud, setWorldCloud] = useState<any[]>([]);
  const [paidHashtags, setPaidHashtags] = useState<any[]>([]);
  const [organicHashtags, setOrganicHashtags] = useState<any[]>([]);
  const [paidComments, setPaidComments] = useState<any[]>([]);
  const [organicComments, setOrganicComments] = useState<any[]>([]);
  const [totalCommentsCount, setTotalCommentsCount] = useState<any[]>([]);
  const [emvGraph, setEmvGraph] = useState<any[]>([]);
  const [amountGraph, setAmountGraph] = useState<any[]>([]);
  const [brandData, setBrandData] = useState<any[]>([]);
  const [paidOrganicImageVideoER,setPaidOrganicImageVideoER] = useState<any[]>([]);
  const [influencerEngagementSummary,setInfluencerEngagementSummary] = useState<any[]>([]);
  const [influencerEngagementSummaryPaid,setInfluencerEngagementSummaryPaid] = useState<any[]>([]);
  const [keyInsightsPaid,setKeyInsightsPaid] = useState<any[]>([]);
  
  const [influencerEngagementGraphPaid,setInfluencerEngagementGraphPaid] = useState<any[]>([]);
  const [influencerEngagementGraphOrganic,setInfluencerEngagementGraphOragnic] = useState<any[]>([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [dayRange, setDayRange] = useState<RangeType>("90");
  const [searchExpand, setSearchExpand] = useState(false)
  const [showSearchBar, setShowSearchBar] = useState(true);
  const [amount, setAmount] = useState("")
  const [loadingAccordion, setLoadingAccordion] = useState(false);
  const [selectedTab, setSelectedTab] = useState<"brands" | "influencer">("influencer");
  const [selectedInnerTab, setSelectedInnerTab] = useState<"image" | "video">("video");
  // For Getting Brand Data
  const [profileLoading, setProfileLoading] = useState(false)
  
  const [hasSearched, setHasSearched] = useState(false)
  const [dataApi6, setDataApi6] = useState<any>([]);
  const [profileUpdatedAt,setProfileUpdatedAt] = useState(0);

  const [detailedInfluencerTableData, setDetailedInfluencerTableData] = useState<InfluencerTableData>({
    paid: [],
    paid_videos: [],
    paid_images: [],
    brand_organic: [],
    brand_organic_videos: [],
    brand_organic_images: [],
    brand: [],
    brand_videos: [],
    brand_images: [],
    total: "",
    total_pages: "",
  });
  
  const [activeAccordion, setActiveAccordion] = useState<AccordionType>("paid");
  const navigate = useNavigate();
  


  useEffect(() => {
    // CHECK IF USER ALLOWED  ACCESS 
    checkAccessFunction();
  }, []);


  function getTimeDifference(givenDateStr:any) {
    const givenDate:any = new Date(givenDateStr);
    const now :any= new Date();
    let diffMs = Math.abs(now - givenDate);
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    diffMs %= (1000 * 60 * 60 * 24);
    return  days ;
  }
  
  const checkAccessFunction = async () => {
    try {
      const res = await rolesService.checkAccess({ access_roles: ["brand_pulse"], user_id: props?.UserReducer?.user_id })
      if (res.data.rows.length > 0) {
        setUserStatus(true);
      }
      else {
        localService.toastify("You are not allowed to access", "error", 1000);
        navigate(`/`);
      }
    }
    catch (error) {
      console.error('Error fetching getAdminDashData:', error);

    }
  }
  // For Searching Items.......

  const handleSearchBar = async ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const inputValue = target.value.toLowerCase();
      setSearchValue(inputValue);
      if (!inputValue || inputValue.length < 3) {
        setSearchList([]);
        return;
      }
      const response = await brandDataService.getBrandSearch(inputValue);
      if (response.status == gtUtil.Constants.SUCCESS) {
        setSearchList(response.data.rows);
        setBrandImage(response.data.rows)
      }
    }
    catch (error) {
      console.log(`getBrandSearch error :: ${JSON.stringify(error)}`);
    }
  };

  // For Rendring Profile List Items....................................

  const renderProfileListItem = (item: any) => {
    return <>
      <li className="insta-search-list" key={item?.ref_id}>
        <div className="col">
          <div className="d-flex flex-wrap align-items-center" onClick={() => handleSelectItem(item)}>
            <span onClick={() => handleSelectItem(item)}>
              {item?.platform === 'instagram' ? <InstagramIcon1 width={25} /> : <YouTube fontSize="small" style={{ color: 'red' }} />}
            </span>
            <strong>
              <span className="insta-username insta-search-username mx-2" onClick={() => handleSelectItem(item)}>
                {item?.platform === 'instagram' ? item?.username : item?.title}
              </span>
            </strong>
            <span className="ms-auto" style={{ color: 'black' }} onClick={() => handleSelectItem(item)}>
              <Launch fontSize="small" sx={{ height: 'auto' }} />
            </span>
          </div>
        </div>
        <p>
          <span style={{ textDecoration: 'none', color: 'black' }} onClick={() => handleSelectItem(item)}>
            {item.platform === 'instagram' ? item?.insta_name : item?.title}
          </span>
        </p>
      </li>
    </>

  };
  const handleSelectItem = (item: any) => {
    const displayName = item?.platform === 'instagram' ? item?.username : item?.title;
    setSearchValue(displayName); // ✅ fill the input field
    setIsSelected(false);        // ✅ hide suggestion list
    handleBrandData(item?.ref_id); // ✅ trigger main action
  };


  const [EnggSnapshotPaidData, setEnggSnapshotPaidData] = useState()
  const [EnggSnapshotOrganicData, setEnggSnapshotOrganicData] = useState()
  const [EnggSnapshotBrandData, setEnggSnapshotBrandData] = useState()
  const [EnggSnapshotData, setEnggSnapshotData] = useState()

  const handleBrandData = async (selectedRefId: any) => {
    try {
      // loading(true);
      setIsSelected(false);
      setProfileLoading(true)
      setHasSearched(true);
      const response = await brandDataService.profileCard(selectedRefId);
      if (response.status == gtUtil.Constants.SUCCESS) {
        loading(false);
        setProfileLoading(false)
        setBrandRefId(selectedRefId);
        setProfileData(response.data.rows.brand_profile)
        setDataApi1(response.data.rows);
        setProfileData(response.data.rows.brand_profile);
        const time_duration = getTimeDifference(response.data.rows.brand_profile[0].updated_at);
        setProfileUpdatedAt(time_duration);
        const response3 = await brandDataService.topData(selectedRefId);
        if (response3.status == gtUtil.Constants.SUCCESS) {
          setTopPaidInfluencer(response3.data.rows.top_paid_influencers)
          setTopOrganicInfluencer(response3.data.rows.top_organic_influencers)
          setTopCompetitors(response3.data.rows.top_competitors)
          setDataApi3(response3.data.rows)
        }
        
        handleDayRange(selectedRefId,90)
        const response6 = await brandDataService.getSimailarBrandInfluencers(selectedRefId);
        if (response6.status == gtUtil.Constants.SUCCESS) {
          setinfluencerData(response6.data.rows.similar_influencers)
          setBrandData(response6.data.rows.similar_brands)
        }
        // const day_range:any = profileUpdatedAt ? Number(dayRange) + profileUpdatedAt : Number(dayRange) + 0

      }
    } catch (error) {
      console.log(`Brand Pulse Api :: ${JSON.stringify(error)}`);
    } finally {
      loading(false);

    }
  }

  const [loadingMetricCard, setLoadingMetricCard] = useState(false);
  const [loadingGrowthChart, setLoadingGrowthChart] = useState(false);
  const [loadingAmountEmvGraph, setLoadingAmountEmvGraph] = useState(false);
  const [loadingComments, setLoadingComments] = useState(false);
  const [loadingHashtags, setLoadingHashtags] = useState(false);
  const [loadingEngagementSummary, setLoadingEngagementSummary] = useState(false);
  const [loadingEngagementGraph, setLoadingEngagementGraph] = useState(false);
  const [loadingSnapshot, setLoadingSnapshot] = useState(false);
  const [loadingComparison, setLoadingComparison] = useState(false);
  const handleDayRange = async (selectedRefId: any, range: any) => {
    const day_range: any = profileUpdatedAt ? Number(range) + profileUpdatedAt : Number(range) + 0;
  
    // SECTION 1: Metric Card
    setLoadingMetricCard(true);
    try {
      const response2 = await brandDataService.metricCard(selectedRefId, day_range);
      if (response2.status === gtUtil.Constants.SUCCESS) {
        const data = response2.data.rows;
        if (data.brand_post_frequency_data.length > 0) {
          setPostFrequency(data.brand_post_frequency_data[0]);
          setPaidFrequency(data.brand_post_frequency_data[0]["paid_post_value"]);
          setOrganicFrequency(data.brand_post_frequency_data[0]["brand_organic_post_value"]);
          setPaidOrganicImageVideoER(data.paid_organic_image_video_er);
          setPaidOrganicER(data.paid_organic_er);
        }
        setProfileEr(data.profile_er);
        setAmount(data.amount);
        setDataApi2(data);
      }
    } finally {
      setLoadingMetricCard(false);
    }
  
    // SECTION 2: Growth Chart
    setLoadingGrowthChart(true);
    try {
      const response9 = await brandDataService.growthChart(selectedRefId, day_range);
      if (response9.status === gtUtil.Constants.SUCCESS) {
        const data = response9.data.rows;
        if (Array.isArray(data.subscriber_growth_chart)) {
          setSubsGrowthStockChartData(data.subscriber_growth_chart);
        }
        setContentTypeChart(data.content_chart);
        setPostErChart(data.er_chart);
        setDataApi6(data);
      }
    } finally {
      setLoadingGrowthChart(false);
    }
  
    // SECTION 3: Amount & EMV Graph
    setLoadingAmountEmvGraph(true);
    try {
      const response7 = await brandDataService.amountEMVGraph(selectedRefId, day_range);
      if (response7.status === gtUtil.Constants.SUCCESS) {
        const data = response7.data.rows;
        setAmountGraph(data.amount_graph);
        setEmvGraph(data.emv_graph);
      }
    } finally {
      setLoadingAmountEmvGraph(false);
    }
  
    // SECTION 4: Comments
    setLoadingComments(true);
    try {
      const response4 = await brandDataService.getComments(selectedRefId, day_range);
      if (response4.status === gtUtil.Constants.SUCCESS) {
        const data = response4.data.rows;
        setTotalCommentsCount(data.totalCommentsCount);
        setPaidComments(data.paid_comments);
        setOrganicComments(data.organic_comments);
        setDataApi4(data);
      }
    } finally {
      setLoadingComments(false);
    }
  
    // SECTION 5: Hashtags
    setLoadingHashtags(true);
    try {
      const response5 = await brandDataService.hashtags(selectedRefId, day_range);
      if (response5.status === gtUtil.Constants.SUCCESS) {
        const data = response5.data.rows;
        setPaidHashtags(data.paid_hashtags);
        setOrganicHashtags(data.organic_hashtags);
        setDataApi5(data);
      }
    } finally {
      setLoadingHashtags(false);
    }
  
    // SECTION 6: Engagement Summary
    setLoadingEngagementSummary(true);
    try {
      const response8 = await brandDataService.influencerEngagementSummary(selectedRefId, day_range);
      if (response8.status === gtUtil.Constants.SUCCESS) {
        const data = response8.data.rows;
        setInfluencerEngagementSummaryPaid(data.influencer_enagagement_summary_paid);
        setKeyInsightsPaid(data.key_insights_paid);
      }
    } finally {
      setLoadingEngagementSummary(false);
    }
  
    // SECTION 7: Engagement Graph
    setLoadingEngagementGraph(true);
    try {
      const response10 = await brandDataService.influencerEngagementGraph(selectedRefId, day_range);
      if (response10.status === gtUtil.Constants.SUCCESS) {
        const data = response10.data.rows;
        setInfluencerEngagementGraphPaid(data.influencer_enagagement_graph_paid);
        setInfluencerEngagementGraphOragnic(data.influencer_enagagement_graph_paid);
      }
    } finally {
      setLoadingEngagementGraph(false);
    }
  
    // SECTION 8: Snapshot Summary
    setLoadingSnapshot(true);
    try {
      const response11 = await brandDataService.snapshotSummary(selectedRefId, "paid", day_range);
      if (response11.status === gtUtil.Constants.SUCCESS) {
        setEnggSnapshotData(response11?.data?.rows?.[0] || {});
      }
    } finally {
      setLoadingSnapshot(false);
    }
  
    // SECTION 9: Brand Comparison
    setLoadingComparison(true);
    try {
      const res = await brandDataService.compareBrandData(selectedRefId, day_range);
      if (res.status === gtUtil.Constants.SUCCESS) {
        setComparisionData(res.data.rows);
      }
    } finally {
      setLoadingComparison(false);
    }
  
    // Fire-and-forget call (no loading state needed unless UI depends on it)
    await influencerBrandData(selectedRefId, selectedTab, "image", "paid", day_range);
    await influencerBrandData(selectedRefId, "influencer", "video", "paid", day_range);
  };
  
   

  
  type RangeType = "7" | "15" | "30" | "90" |  "180" | "1000";
  const influencerBrandData = async (
    selectedRefId: any,
    media_type: "influencer" | "brands",
    type: "image" | "video",
    paid_type?: "paid" | "brand_organic" | "brand",
    day_range?: RangeType,
  ) => {
    setLoadingAccordion(true);
    try {
      const range:any = profileUpdatedAt ? Number(day_range) + profileUpdatedAt : Number(day_range) + 0

      const response = await brandDataService.getEngagedInfluencer(
        selectedRefId,
        media_type,
        type,
        paid_type,
        range
      );
  
      // check for error, missing data, or empty rows
      if (
        response.status !== gtUtil.Constants.SUCCESS ||
        !response.data ||
        !response.data.rows ||
        response.data.rows.length === 0
      ) {
        if (paid_type) {
          setDetailedInfluencerTableData(prev => ({
            ...prev,
            [paid_type]: [],
            [`${paid_type}_videos`]: [],
            [`${paid_type}_images`]: [],
            total: "0",           // ✅ as string
            total_pages: "0",     // ✅ as string
            [`${paid_type}_noData`]: true,
          }));
        }
        return;
      }
  
      // success and has data
      if (paid_type) {
        setBrandRefId(selectedRefId);
        const videoContent = response.data.rows.filter(
          (item: any) =>
            item.content_type?.toLowerCase() === "reel" ||
            item.content_type?.toLowerCase() === "video"
        );
  
        const imageContent = response.data.rows.filter(
          (item: any) =>
            item.content_type?.toLowerCase() !== "reel" &&
            item.content_type?.toLowerCase() !== "video"
        );
  
        setDetailedInfluencerTableData(prev => ({
          ...prev,
          [paid_type]: response.data.rows,
          [`${paid_type}_videos`]: videoContent,
          [`${paid_type}_images`]: imageContent,
          total: String(response.data.total),        // ✅ convert to string
          total_pages: String(response.data.total_pages), // ✅ convert to string
          [`${paid_type}_noData`]: false,
        }));
      }
        const response12 = await brandDataService.snapshotSummary(selectedRefId,paid_type,range);
        if (response12.status == gtUtil.Constants.SUCCESS) {
          setEnggSnapshotData(response12?.data?.rows?.[0] || {})
        }

    } catch (error) {
      console.log(`Brand Pulse Api :: ${JSON.stringify(error)}`);
    } finally {
      loading(false);
      setLoadingAccordion(false);
    }
  };
  


  const handleSelect = (eventKey: any) => {
  };

  const totalFollowers = influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.influencer_count, 0);
  const totalPosts =  influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.record_count, 0);
  const totalAmountSpent = influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.total_amount, 0);

  const totalEMV = influencerEngagementSummaryPaid.length > 0 &&  influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.emv_total, 0);

  const totalER =  influencerEngagementSummaryPaid.length > 0 && influencerEngagementSummaryPaid?.reduce((sum: number, item: any) => sum + item.average_er, 0);

  const [isDurationLoading, setIsDurationLoading] = useState(false);
  const handleChange = (event:any) => {
    const selectedRange = event.target.value;
    setDayRange(selectedRange);
    handleDayRange(brandRefId, selectedRange);
  };

  const handleTabSelect = async (key: any, innerKey: any) => {
    setSelectedTab(key);
    setSelectedInnerTab(innerKey);
  
    const mediaType = key === "influencer" ? "influencer" : "brands";
    const contentType = innerKey === 'video' ? "video" : "image";
    if (activeAccordion !== null) {
      try {
        await influencerBrandData(brandRefId, mediaType, contentType, activeAccordion, dayRange);
      } catch (error) {
        console.error("Failed to fetch influencer brand data:", error);
      }
    }
  };
  const searchRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsSelected(false); 
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const handleSearchExpand = () =>{
    setSearchExpand(prev => !prev)
  }
 

// useEffect(() => {
//   const handleScroll = () => {
//     if (window.scrollY > 100) {
//       setShowSearchBar(false);
//     } else {
//       setShowSearchBar(true);
//     }
//   };

//   window.addEventListener('scroll', handleScroll);
//   return () => window.removeEventListener('scroll', handleScroll);
// }, []);




const getInfluencerTypesWithRange = (items: any[]) => {
  return items
    .map((item:any) => {
      const range:any = influencerTypeRange[item.influencer_type] || "";
      return `${item.influencer_type} (${range})`;
    })
    .join(" & ");
};

const metricConfig = {
  total_amount: {
    icon: "💰",
    label: "Maximum Spend",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers received the highest investment - <strong>₹{methods.convertExactNumber(value)}</strong></>
  },
  record_count: {
    icon: "🧑‍💼",
    label: "Most Active Contributors",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers topped the volume with <strong>{methods.convertExactNumber(value)}</strong> posts.</>
  },
  average_er: {
    icon: "🔥",
    label: "Highest Engagement Rate",
    template: (types:any, value:any) =>
      <> <strong>{types}</strong> Influencers lead with a <strong>{value.toFixed(2)}%</strong> ER.</>
  },
  emv_total: {
    icon: "💎",
    label: "Top Earned Media Value (EMV)",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers generated the highest EMV at <strong>₹{methods.convertExactNumber(value)}</strong></>
  },
  followers_total: {
    icon: "👥",
    label: "Top Reach",
    template: (types:any, value:any) =>
      <><strong>{types}</strong> Influencers reached the highest follower base – <strong>{methods.convertExactNumber(value)}</strong></>
  }
};
const [addCompetitorToTable, setAddCompetitorToTable] = useState()
const [errorMsg, setErrorMsg] = useState<string | null>(null);
const handleAddCompetitorComparison = async (selectedRefId: any) => {
  const existingRefIds = new Set(comparisionData.map(item => item.ref_id.toString()));
  if (existingRefIds.has(selectedRefId.toString())) {
    setErrorMsg("This brand is already added to the comparison.");
    return;
  }

  if (comparisionData.length >= 3) {
    setErrorMsg("You can compare a maximum of 2 competitors.");
    return;
  }

  try {
    const response = await brandDataService.getCompareBrandAddOn(selectedRefId, dayRange);
    if (response.status === gtUtil.Constants.SUCCESS) {
      const newItem = response.data.rows;
      if (newItem) {
        setComparisionData(prev => [...prev, newItem]);
        setErrorMsg(null);
      } else {
        setErrorMsg("Failed to retrieve brand data.");
      }
    } else {
      setErrorMsg("Error fetching brand comparison data.");
    }
  } catch (err: any) {
    console.error("Add competitor error:", err);
    setErrorMsg("An unexpected error occurred.");
  }
};


const handleClose = (ref_id: string) => {
  setComparisionData(prev => prev.filter(item => item.ref_id !== ref_id));
};

  return (
    <>
    
      {userStatus && <div className='d-flex justify-content-center align-items-center brand-pulse'>                                                            
        {/* .....................For Search Bar................................... */}
        <div className='container custom-container position-relative'>
        {showSearchBar && (
  <>
    {/* <span onClick={handleSearchExpand} className='search-expand'>
      <MaterialSymbol iconName='search' fontweight='200' />
    </span> */}

    <div className="search-container-content">
      <InstagramIcon className="search-plt-type-icon icon-instagram" width={20} height={20} />
      <form className="d-flex">
        <input
          type="search"
          placeholder="Search by name or username"
          className="form-control"
          id="brand-search-by-name"
          onChange={handleSearchBar}
          onClick={() => setIsSelected(true)}
          value={searchValue}
        />
        <button
          type="button"
          className="btn d-flex btn-search"
          onMouseDown={(e) => e.preventDefault()}
        >
          <Search />
        </button>
      </form>
      {searchList.length > 0 && isSelected && (
        <div className="search-suggestion" style={{ cursor: 'pointer' }}>
          <ul>
            {searchList.slice(0, 10).map((item: any) => renderProfileListItem(item))}
          </ul>
        </div>
      )}
    </div>
  </>
)}
        
        </div>
        {/* .....................End of Search Bar................................... */}

      </div>
      }
      {brandRefId &&
        <>
          <div style={{ paddingTop: '24px', paddingBottom: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <div className='container custom-container'>
                <>
                  <div className='brand-pulse-duration-select'>
                    <FormControl fullWidth>
                    <InputLabel id="select-label" sx={{ backgroundColor: 'white', px: 0.5 }}>
                      Showing data for last
                    </InputLabel>
                      <Select
                        labelId="select-label"
                        id="select"
                        value={dayRange}
                        label="Select an option"
                        onChange={handleChange}
                      >
                        <MenuItem value="7">7 Days</MenuItem>
                        <MenuItem value="15">15 Days</MenuItem>
                        <MenuItem value="30">30 Days</MenuItem>
                        <MenuItem value="90" selected >90 Days</MenuItem>
                        <MenuItem value="180" disabled>180 Days</MenuItem>
                        <MenuItem value="365" disabled> 1 year</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  {hasSearched &&<BrandPulseProfileCard loader={
                    profileLoading} profileData={profileData} />}
                  </>
              
                <>
                
                {Object.keys(dataApi2).length > 0 && <MetricsCard profileEr={profileEr} postFrequency={postFrequency} paidFrequency={paidFrequency} organicFrequency={organicFrequency} paidOrganicEr={paidOrganicER} budget={amount} paidOrganicImageVideoER={paidOrganicImageVideoER} loader={loadingMetricCard} dayRange = {dayRange}/>}
                  <Grid container spacing={2} className="mt-2 mb-3">
                  {Object.keys(dataApi6).length > 0 && (
                    <>
                      <Grid item xs={12} md={6} lg={4}>
                        <FollowersGrowthChart loader={loadingGrowthChart} subsGrowthStockChartData={subsGrowthStockChartData} />
                      </Grid>

                      <Grid item xs={12} md={6} lg={4}>
                        <ContentTypeChart loader={loadingGrowthChart} subsGrowthStockChartData={contentTypeChart} />
                      </Grid>

                      {postErChart.length > 0 && (
                        <Grid item xs={12} md={6} lg={4}>
                          <PostErChart postErChart={postErChart} loader={loadingGrowthChart} />
                        </Grid>
                      )}
                    </>
                  )}
                  </Grid>
                  <Grid container spacing={2} className="mb-3">
                    {Object?.keys(dataApi3).length > 0 &&
                      <Grid item xs={12} sm={12} md={12}>
                        <TopInfluencer topPaidInfluencer={topPaidInfluencer} topOrganicInfluencer={topOrganicInfluencer} topCompetitors={topCompetitors} />
                      </Grid>
                    }
                  </Grid>
                  <Grid container spacing={2} className="mb-3">
                    {emvGraph.length > 0  && (
                      <Grid item xs={12} sm={12} md={6}>
                        <EmvChart emvGrowthChart={emvGraph} />
                      </Grid>
                    )}
                    {(amountGraph.length > 0) &&
                      <Grid item xs={12} sm={12} md={6}>
                        <EmvROI amountGraph={amountGraph} />
                      </Grid>
                    }
                  </Grid>

                  {influencerEngagementSummaryPaid.length > 0 &&
                    <Grid item xs={12} sm={12} md={12} className='mb-3'>
                      <section className="brand-insight-highchart">
                        <div className="brand-insight-highchart-top">
                          <strong className="brand-insight-highchart-title d-flex flex-column">
                            Influencer Engagement Summary
                          </strong>
                        </div>
                        <div className="brand-insight-highchart-data">
                          <Grid container spacing={2} className="mt-2">
                            <Grid item xs={12} md={12} lg={8} xl={8}>
                              <strong>Key Insights:</strong>
                              <ul className='key-insight-list'>
                                {Object.entries(metricConfig).map(([metric, config]) => {
                                  const filtered = keyInsightsPaid.filter(item => item.metric === metric);
                                  if (!filtered.length) return null;

                                  const maxValue = Math.max(...filtered.map(item => item.MAX_VALUE));
                                  const topItems = filtered.filter(item => item.MAX_VALUE === maxValue);
                                  const influencerTypes = getInfluencerTypesWithRange(topItems);

                                  return (
                                    <li key={metric}>
                                      {config.icon} <span>{config.label}</span> : {config.template(influencerTypes, maxValue)}
                                    </li>
                                  );
                                })}                                 
                              </ul>
                            </Grid>
                            <>
                              <Grid className='' item xs={12} md={12} lg={4} xl={4}>
                                <EngagedInfluencers data={influencerEngagementSummaryPaid} />

                              </Grid>
                              <Grid item xs={12} md={12} lg={4} xl={4} className="">
                                <EngagedInfluencersAmount data={influencerEngagementSummaryPaid} />

                              </Grid>
                            </>
                            {influencerEngagementGraphOrganic.length > 0 && <Grid item xs={12} md={12} lg={8} xl={8} >
                              <div className="infl-engg-er infl-engg-common-bg">
                                <div className="d-flex flex-column">
                                  <span className="infl-engg-ratio-title" >Engagement Rate </span> <BrandErVerticalChart erOrganic ={influencerEngagementGraphOrganic} />
                                </div>
                              </div>
                            </Grid>
                            }
                            <Grid columns={10} container spacing={2} className="mt-2 ms-0">
                            <Grid item xs={12} md={2} lg={2} xl={2}>
                              <div className='engagement-detail'>
                                <span>No. of Influencers</span>
                                <strong>{totalFollowers}</strong>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={2} lg={2} xl={2}>
                              <div className='engagement-detail'>
                                <span>Total Posts Created</span>
                                <strong>{totalPosts}</strong>
                              </div>
                            </Grid>
                            
                            <Grid item xs={12} md={2} lg={2} xl={2}>
                              <div className='engagement-detail'>
                                <span>Overall Engagement Rate</span>
                                <strong>{totalER?.toFixed(2)}%</strong>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={2} lg={2} xl={2}>
                              <div className='engagement-detail'>
                                <span>Amount Spent</span>
                                <strong>{methods.convertExactNumber(totalAmountSpent)}</strong>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={2} lg={2} xl={2}>
                              <div className='engagement-detail'>
                                <span>Earned Media Value (EMV)</span>
                                <strong>
                                  {methods.convertExactNumber(totalEMV)}</strong>
                              </div>
                            </Grid>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12} xl={12}>
                              <EngagedInfluencerTable type={influencerEngagementSummaryPaid[0].paid_type} detailedInfluencer={influencerEngagementSummaryPaid} />
                            </Grid>
                          </Grid>

                        </div>
                      </section>
                    </Grid>

            }

            {/* {detailedInfluencer.length > 0 && <DetailedInfluencerAnalytics detailedInfluencer={detailedInfluencer} />} */}
            <Grid container spacing={3} className="mb-3">
              {Object.keys(dataApi4).length > 0 &&
                <Grid item xs={12} sm={12} md={12}>
                  <CommentsTab paidComments={paidComments} organicComments={organicComments} totalCommentsCount={totalCommentsCount} />
                </Grid>
              }
              {Object.keys(dataApi5).length > 0 && (
                <Grid item xs={12} sm={12} md={6}>
                  <WordCloudComponent words={paidHashtags} componentName="Paid Hashtags" />
                </Grid>)
              }
              {Object.keys(dataApi5).length > 0 &&
                <Grid item xs={12} sm={12} md={6}>
                  <WordCloudComponent words={organicHashtags} componentName="Organic Hashtags" />
                </Grid>
              }
            </Grid>
            {/* <DetailedInfluencerAnalytics
            title="Paid Influencer Engagement Snapshot"
              detailedInfluencer={detailedInfluencerTableData}
              onTabSelect={handleTabSelect}
            />

            <DetailedInfluencerAnalytics
            title="Organic Influencer Engagement Snapshot"
              detailedInfluencer={detailedInfluencerTableData}
              onTabSelect={handleTabSelect}
            />

            <DetailedInfluencerAnalytics 
            title="All Influencer Engagement Snapshot"
              detailedInfluencer={detailedInfluencerTableData}
              onTabSelect={handleTabSelect}
            /> */}
            <section className="brand-insight-highchart">
              <div className="brand-insight-highchart-top">
                <strong className="brand-insight-highchart-title d-flex flex-column">
                    Engagement Snapshot
                </strong>
              </div>
              <div className={`brand-pulse-influencer-details-table mb-3`}>
                
                  <div className='engg-snapshot-data brand-insight-highchart-data px-0'>
                  <Tab.Container
                    defaultActiveKey="paid"
                    onSelect={async (eventKey) => {
                      let newAccordion:any;
                      if (eventKey === activeAccordion) {
                        newAccordion = undefined;
                      } else {
                        newAccordion = eventKey === "paid" ? "paid" : eventKey === "organic" ? "brand_organic" : "brand";
                      }

                      setActiveAccordion(newAccordion);

                      if (newAccordion !== undefined) {
                        const mediaType = selectedTab === 'influencer' ? 'influencer' : 'brands';
                        const contentType = selectedInnerTab === 'image' ? 'image' : 'video';

                        try {
                          setLoadingAccordion(true);
                          const day_range:any = profileUpdatedAt ? Number(dayRange) + profileUpdatedAt : Number(dayRange) + 0
                          await influencerBrandData(brandRefId, selectedTab, selectedInnerTab, newAccordion, day_range);
                        } catch (error) {
                          console.error("Error fetching data for brand accordion:", error);
                        } finally {
                          setLoadingAccordion(false);
                        }
                      }
                    }}
                  >
                    <Nav className="engg-snapshot-data-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="paid">Paid Influencers</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="organic">Organic/ Tagged Influencers</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="brand">Brand's Own Posts</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content className='engg-snapshot-data-tab-content'>
                      <Tab.Pane eventKey="paid"> 
                        
                      <DetailedInfluencerAnalyticsPaid loader={loadingAccordion} title='Paid Influencer Engagement Snapshot' noData={detailedInfluencerTableData.paid_noData}
                        detailedInfluencer={detailedInfluencerTableData.paid}
                        onTabSelect={handleTabSelect}
                        isOpen={activeAccordion === 'paid'}
                        insight={EnggSnapshotData || {}}  
                      />
                        
                    </Tab.Pane>
                      <Tab.Pane eventKey="organic">
                      <DetailedInfluencerAnalyticsBrandOrganic noData={detailedInfluencerTableData.brand_organic_noData}
                        detailedInfluencer={detailedInfluencerTableData.brand_organic}
                        onTabSelect={handleTabSelect}
                        isOpen={activeAccordion === 'brand_organic'}
                        loader={loadingAccordion}
                        insight={EnggSnapshotData}
                      />
                      </Tab.Pane>
                      <Tab.Pane eventKey="brand">
                      <DetailedInfluencerAnalyticsBrand
                        title='All Influencer Engagement Snapshot'
                        detailedInfluencer={detailedInfluencerTableData.brand}
                        noData={detailedInfluencerTableData.brand_noData}
                        onTabSelect={handleTabSelect}
                        isOpen={activeAccordion === 'brand'}
                        loader={loadingAccordion}
                        insight={EnggSnapshotData}
                        
                      />
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                  </div>
              </div>
            </section>
            
                  {brandData.length > 0 && influencerData.length > 0 &&
                    <div className='similar-brand-container'>
                      <Tab.Container defaultActiveKey="brands">
                        <Nav className='similar-brand-tab' onSelect={handleSelect}>
                          <Nav.Item>
                            <Nav.Link eventKey="brands" className='detailed-infl-tab'>Brands</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="influencer" className='detailed-infl-tab'>Influencers</Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <Tab.Content>
                          <Tab.Pane eventKey="brands">
                            {brandData.length > 0 && <InfluencerGrid title="Similar Accounts" influencerData={brandData} />}
                          </Tab.Pane>

                          <Tab.Pane eventKey="influencer">
                            {influencerData.length > 0 && <InfluencerGrid title="Similar Accounts" influencerData={influencerData} />}
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </div>
                  }
                  {comparisionData.length > 0 && brandData.length > 0 && <ComparisionTable handleClose={handleClose} handleAddCompetitorComparison={handleAddCompetitorComparison} error={errorMsg} data={comparisionData} brandData ={brandData} />}
                </>
            </div>
          </div>
        </>
      }
      
      
    </>
  )
}
const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(BrandPulse);

export { connectToRedux as BrandPulse };



